import CoreModule from './core';
import PageModule from "./page-modules/prof";
import VideoModal from "../components/base/video-modal";

class App {
    constructor() {
        window.addEventListener('load', () => {
            this.coreModule = new CoreModule();
            this.pageModule = new PageModule();

            const videoModal = new VideoModal({ id: 'prof-test-v2-video' });
            }, false);
    }
}

const app = new App();